"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNA_VALUES_V4 = exports.DNA_VALUES_V3 = exports.DNA_VALUES = exports.DNA = void 0;
__exportStar(require("./entities"), exports);
__exportStar(require("./functions"), exports);
var DNA;
(function (DNA) {
    DNA["Passion"] = "passion";
    DNA["Competence"] = "competence";
    DNA["Accountability"] = "accountability";
    DNA["GoalGetter"] = "goalgetter";
    DNA["TeamPlayer"] = "teamplayer";
    DNA["Fireball"] = "fireball";
    DNA["Innovator"] = "innovator";
})(DNA = exports.DNA || (exports.DNA = {}));
exports.DNA_VALUES = [
    DNA.Passion,
    DNA.Competence,
    DNA.Accountability,
    DNA.GoalGetter,
    DNA.TeamPlayer,
    DNA.Fireball,
    DNA.Innovator,
];
exports.DNA_VALUES_V3 = [
    DNA.Passion,
    DNA.Competence,
    DNA.Accountability,
    DNA.GoalGetter,
    DNA.TeamPlayer,
];
exports.DNA_VALUES_V4 = [
    DNA.Fireball,
    DNA.Innovator,
    DNA.Competence,
    DNA.Accountability,
    DNA.TeamPlayer,
];
//# sourceMappingURL=index.js.map